if ($('.js-winners-images').length) {
    $('.js-winners-images').modaal({
        type: 'image',
        background: '#f1fbff',
        overlay_opacity: 1,
        background_scroll: false
    });
}